const STYLES = {
  bronze: "bg-amber-50 text-amber-800 border-amber-200",
  silver: "bg-slate-100 text-slate-700 border-slate-300",
  gold: "bg-yellow-50 text-yellow-800 border-yellow-300",
  platinum: "bg-indigo-50 text-indigo-700 border-indigo-200",
};

export const TIER_COLORS = { bronze: "#b45309", silver: "#94a3b8", gold: "#eab308", platinum: "#6366f1" };

export const TierBadge = ({ tier, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize ${STYLES[tier] || "bg-slate-50 text-slate-600 border-slate-200"}`}
  >
    <span className="h-1.5 w-1.5 rounded-full" style={{ background: TIER_COLORS[tier] || "#94a3b8" }} />
    {tier || "—"}
  </span>
);

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-medium ${status === "attivo" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-slate-50 text-slate-500 border-slate-200"}`}
  >
    {status}
  </span>
);
